import * as React from 'react';

var _circle, _circle2, _circle3, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var SvgSettingsIcon = function SvgSettingsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 127 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 102,
    cy: 13,
    r: 11.5,
    stroke: "#D9D9D9",
    fill: "transparent",
    strokeWidth: 3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 52,
    r: 11.5,
    stroke: "#D9D9D9",
    fill: "transparent",
    strokeWidth: 3
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 73,
    cy: 92,
    r: 11.5,
    stroke: "#D9D9D9",
    fill: "transparent",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90 13L2 13",
    stroke: "#D9D9D9",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M125 52L37 52",
    stroke: "#D9D9D9",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60 92L2 92",
    stroke: "#D9D9D9",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M125 13L115 13",
    stroke: "#D9D9D9",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12 52H2",
    stroke: "#D9D9D9",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M125 92H85",
    stroke: "#D9D9D9",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
};

export { SvgSettingsIcon as ReactComponent };
